
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { EditScoreGradeForm } from '@/services/QA/scoreGrade/forms/EditScoreGradeForm';
import { ScoreGradeInterface, ScoreGradeRepositoryInterface } from '@/services/QC-V2/score-grade/interfaces';

@Component({
  inject: [
    'scoreGradeRepositoryV2',
  ],
})
export default class EditScoreGrade extends Vue {
  private readonly scoreGradeRepositoryV2!: ScoreGradeRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<EditScoreGradeForm> = new WPXFormValue(EditScoreGradeForm);
  private scoreGrade!: ScoreGradeInterface;

  public async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  private async initialize(): Promise<void> {
    if (!this.$route.params.scoreGradeId) {
      this.$errorDialog.show('Score Grade Id Not Provided!');
      return;
    }

    this.scoreGrade = await this.scoreGradeRepositoryV2.getOneById(Number(this.$route.params.scoreGradeId));
    this.form.data.label = this.scoreGrade.label;
    this.form.data.value = this.scoreGrade.value;
  }

  private async editScoreGrade(): Promise<void> {
    try {
      await this.scoreGradeRepositoryV2.editScoreGrade(
        this.scoreGrade.id,
        {
          label: this.form.data.label,
          value: Number(this.form.data.value),
        },
      );

      this.$successDialog.show(`Score Grade '${this.form.data.label}' has been edited`);
      await this.$router.push({ name: 'scores' });
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
